type Account = { id: string };

export default class ThirdPartyAccounts {
  declare accounts: Account[];

  constructor({ elements }: { elements: Account[] }) {
    this.accounts = elements;
  }

  getLinkedAccountMap() {
    const map: { [key: string]: boolean } = {};
    this.accounts.forEach(({ id }) => {
      map[id] = true;
    });
    return map;
  }
}
